import {PanelColorSettings} from '@wordpress/block-editor';
import type {SetAttributes} from '../pages/Edit';
import {StyleOptions} from '../WidgetStyles';
import {CheckboxControl, SelectControl, TextControl} from '@wordpress/components';
import {CONFIG} from '../../../globals/config';
import {__} from '@wordpress/i18n';
import {useEffect} from 'react';
import {isScreen} from '../../../globals/helpers';

import styles from './section.pcss';

type Props = {
	attributes: StyleOptions;
	setAttributes: SetAttributes;
};

const bulletStyles = [ {
	label: __( '- default -', 'advanced-sidebar-menu' ),
	value: '',
} ];
Object.entries( CONFIG.styles.bullets ).forEach( ( [ value, label ] ) => {
	bulletStyles.push( {value, label} );
} );

const Settings = ( {attributes, setAttributes}: Props ) => {
	useEffect( () => {
		/**
		 * On the post edit screen, having apply current parent
		 * styles is redundant since the menu does not change.
		 * Instead, we set the values to true, so the styles will
		 * work and hide the inputs.
		 */
		if ( 'post' === CONFIG.currentScreen ) {
			setAttributes( {
				apply_current_page_parent_styles_to_parent: true,
				apply_current_page_styles_to_parent: true,
			} );
		}
	}, [ setAttributes ] );

	return (
		<div className={styles.wrap}>
			<h3>{__( 'Settings', 'advanced-sidebar-menu' )}</h3>
			{! isScreen( [ 'post' ] ) && <CheckboxControl
				label={__( 'Apply current item styles to the highest level parent item (when applicable)', 'advanced-sidebar-menu' )}
				checked={true === attributes.apply_current_page_styles_to_parent}
				onChange={value => {
					setAttributes( {
						apply_current_page_styles_to_parent: value,
					} );
				}}
			/>}
			{! isScreen( [ 'post' ] ) && <CheckboxControl
				label={__( 'Apply current item parent styles to the highest level parent item (when applicable)', 'advanced-sidebar-menu' )}
				checked={true === attributes.apply_current_page_parent_styles_to_parent}
				onChange={value => {
					setAttributes( {
						apply_current_page_parent_styles_to_parent: value,
					} );
				}}
			/>}
			<SelectControl
				label={__( 'Bullet style', 'advanced-sidebar-menu' )}
				labelPosition={'side'}
				value={attributes.bullet_style ?? ''}
				options={bulletStyles}
				onChange={value => {
					setAttributes( {
						bullet_style: value,
					} );
				}} />
			<CheckboxControl
				label={__( 'Use blocked styling', 'advanced-sidebar-menu' )}
				checked={true === attributes.block_style}
				onChange={value => {
					setAttributes( {
						block_style: value,
					} );
				}}
			/>
			{true === attributes.block_style && <>
				<CheckboxControl
					label={__( 'Show borders', 'advanced-sidebar-menu' )}
					checked={true === attributes.border}
					onChange={value => {
						setAttributes( {
							border: value,
						} );
					}}
				/>
				{true === attributes.border && <>
					<PanelColorSettings
						className={styles.colors}
						colorSettings={[ {
							value: attributes.border_color,
							onChange: color => setAttributes( {
								border_color: color,
							} ),
							label: __( 'Border color', 'advanced-sidebar-menu' ),
						} ]}
					/>
					<TextControl
						className={styles.size}
						label={__( 'Border width (px)', 'advanced-sidebar-menu' )}
						step={1}
						min={1}
						size={5}
						value={attributes.border_width ?? ''}
						type={'number'}
						onChange={value => {
							setAttributes( {
								border_width: parseInt( value ) ?? 1,
							} );
						}} />
				</>}
			</>}
		</div>
	);
};

export default Settings;
